import { render, staticRenderFns } from "./LivePerson.vue?vue&type=template&id=5e444e40&scoped=true"
import script from "./LivePerson.vue?vue&type=script&lang=js"
export * from "./LivePerson.vue?vue&type=script&lang=js"
import style0 from "./LivePerson.vue?vue&type=style&index=0&id=5e444e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e444e40",
  null
  
)

export default component.exports